// The modules supported by module switcher
const enum Module {
    Mail,
    Calendar,
    People,
    Feedback,
    Options,
    Survey,
    Search,
    Diagnostics,
    ToDo,
}

export default Module;
